import React, {useState} from 'react';
import axios from "axios";


const TestLayout2 = () => {
	const [mail, setMail] = useState('');
	const [subject, setSubject] = useState('');
	const [type, setType] = useState('');
	const [from, setFrom] = useState('');

	const sendMail = () => {
		axios
			.post('/atlantis-api-v1/API/messagesService/sendFakeMail', {
				sendTo: mail,
				subject: subject,
				testoMail: type,
				operatore: from
			})
			.then(() => alert('email inviata!'))
			.catch(() => alert('Errore!!!!!'))
	}

	return (
		<React.Fragment>
			<div style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: 'center',
				alignItems: "center",
				alignContent: "center",
				fontSize: 30
			}}>
				<div style={{width: 200, margin: "auto"}}>
					<button onClick={sendMail}>
						manda email falsa
					</button>
					<br/>
					<input type={"text"} placeholder={'mail'} value={mail} onChange={event => setMail(event.target.value)}/><br/>
					<input type={"text"} placeholder={'subject'} value={subject}
					       onChange={event => setSubject(event.target.value)}/><br/>
					<input type={"text"} placeholder={'type'} value={type} onChange={event => setType(event.target.value)}/><br/>
					<input type={"text"} placeholder={'operatore'} value={from} onChange={event => setFrom(event.target.value)}/><br/>
				</div>
			</div>
		</React.Fragment>
	);
}

export default React.memo(TestLayout2);
